import { Menu, MenuButton, MenuList, MenuItem, VStack, HStack } from '@chakra-ui/react';
import { ChevronRightIcon, CheckIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { IconButton } from 'Atoms';
import { FilterIcon } from 'Tokens/Icons/Function';
import { Typography } from 'Tokens';
import { SearchInput } from 'Molecules/SearchInput';

export type filterOptions = {
  [title: string]: string[];
};

export const HistorySideBarFilter = ({
  filterOptions,
  selected,
  setSelected,
}: {
  filterOptions: filterOptions;
  selected?: { [x: string]: string[] };
  setSelected?: (val: { [x: string]: string[] }) => void;
}) => {
  const [submenu, setSubmenu] = useState<string | null>(null);
  const [search, setSearch] = useState('');

  const handleSelect = (label: string, option: string) => {
    const currentOptions = selected?.[label] || [];
    const isSelected = currentOptions.includes(option);
    const updatedOptions = isSelected
      ? currentOptions.filter((opt) => opt !== option)
      : [...currentOptions, option];
    const updatedSelected = {
      ...selected,
      ...(updatedOptions.length > 0 ? { [label]: updatedOptions } : {}),
    };

    if (updatedOptions.length === 0) {
      delete updatedSelected[label];
    }
    setSelected?.(updatedSelected);
  };

  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        as={IconButton}
        size="md"
        variant="secondary"
        icon={<FilterIcon color="inherit" />}
        aria-label="filter through history"
      />
      <MenuList minW="200px" padding="6px">
        {Object.keys(filterOptions)
          .filter((op) => filterOptions[op].length)
          .map((label) => (
            <MenuItem
              key={label}
              onMouseEnter={() => setSubmenu(label)}
              position="relative"
              _hover={{ bg: 'bg.selected' }}
              onMouseLeave={() => setSubmenu(null)}
            >
              <HStack justify="space-between" align="center" w="100%" gap="12px">
                <Typography variant="bodyStrong">{label}</Typography>
                <ChevronRightIcon />
              </HStack>

              {submenu === label && (
                <VStack
                  position="absolute"
                  top="0"
                  right="100%"
                  bg="white"
                  boxShadow="md"
                  borderRadius="md"
                  p={2}
                  zIndex={999}
                  minW="220px"
                >
                  <SearchInput
                    search={search}
                    setSearch={setSearch}
                    placeholder="Search"
                    size="sm"
                    onClick={(e) => e.stopPropagation()}
                  />
                  <VStack align="start" spacing={1} maxH={500} overflowY="auto" w="100%">
                    {filterOptions[label]
                      .filter((opt) => opt.toLowerCase().includes(search.toLowerCase()))
                      .map((item) => {
                        const isSelected = Object.values(selected ?? {}).some((opt) =>
                          opt.includes(item)
                        );
                        return (
                          <HStack
                            key={item}
                            justify="space-between"
                            align="center"
                            w="100%"
                            padding="8px"
                            borderRadius="md"
                            cursor="pointer"
                            _hover={{ bg: 'bg.hover' }}
                            onClick={() => handleSelect(label, item)}
                          >
                            <Typography
                              variant="bodyStrong"
                              color={isSelected ? 'text.selected' : undefined}
                            >
                              {item}
                            </Typography>
                            {isSelected && <CheckIcon color="text.selected" boxSize={3} />}
                          </HStack>
                        );
                      })}
                  </VStack>
                </VStack>
              )}
            </MenuItem>
          ))}
      </MenuList>
    </Menu>
  );
};
